var exports = {
  "UJ": "CreateIssueDialogHeaderContainer__buXy8A",
  "Y7": "dialogTitleSection__T0EKHg",
  "Nn": "dialogTitleSectionWithSwitcher__eABLL8",
  "W4": "CopyToClipboardIconButton__wkDUlN",
  "Gv": "backButton__urNvXD",
  "q1": "titleSwitcherRow__EpH4Y0",
  "eJ": "switcherButton__merCk_",
};

module.exports = exports;
